module.exports = __webpack_public_path__ + "index.html";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=index.html!./src/build.html
// module id = 13
// module chunks = 0